export TestimonialReview from 'dpl/testimonials/sections/components/TestimonialReview';
export TestimonialPhotoUpload from 'dpl/testimonials/sections/components/TestimonialPhotoUpload';
